import { Routes, Route, Navigate } from 'react-router-dom';
import ToConnectionRequestList from './List/ToConnectionRequestList';
import ToConnectionRequestDetail from './Edit';
import ToConnectionRequestExperience from './Edit/ToConnectionRequestExperience';
import ToConnectionRequestTemplate from './Edit/ToConnectionRequestTemplate';
import BulkEditTabs from './BulkEditTabs';
import ToConnectionRequestHistory from './History/ToConnectionRequestHistory';

const ToConnectionRequest = () => {
  return (
    <Routes>
      <Route path="bulk-edit" element={<BulkEditTabs tab="bulkEdit" />} />
      <Route path="models" element={<BulkEditTabs tab="models" />} />
      <Route path="promotions" element={<BulkEditTabs tab="promotions" />} />
      <Route
        path="connections/:requestId/hotels"
        element={<ToConnectionRequestDetail />}
      />
      <Route
        path="connections/:requestId/experiences"
        element={<ToConnectionRequestExperience />}
      />
      <Route
        path="connections/:requestId/templates"
        element={<ToConnectionRequestTemplate />}
      />
      <Route
        path="connections/:requestId/history"
        element={<ToConnectionRequestHistory />}
      />
      <Route path="connections" element={<ToConnectionRequestList />} />
      <Route path="/" element={<Navigate to="connections" replace />} />
    </Routes>
  );
};

export default ToConnectionRequest;
